import { Hook } from '../hooks-manager';
export const pageParamsEnricherPlugin = function (pageParams) {
  if (pageParams === void 0) {
    pageParams = {};
  }
  return _ref => {
    let {
      hooksManager
    } = _ref;
    const {
      pageUrl
    } = pageParams;
    hooksManager.tap(Hook.beforeReport, eventPayload => {
      if (!pageUrl && typeof window === 'undefined') {
        return;
      }
      eventPayload.httpReferrer = pageUrl ?? window.location.href;
    });
  };
};
//# sourceMappingURL=page-params-enricher-plugin.js.map